"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DispatcherLayout;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _SideMenu = require("@ccw-pwa-ui/SideMenu");
var _images = require("../common_features/assets/images");
var _reactBootstrap = require("react-bootstrap");
var _Header = require("@ccw-pwa-ui/Header");
var _fa = require("react-icons/fa");
var _index = _interopRequireDefault(require("../containers/UserDashboard/index"));
var _AddEmployee = _interopRequireDefault(require("../containers/UserDashboard/AddEmployee"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _DispatcherStoreDashboard = _interopRequireDefault(require("../containers/DispatcherStoreDashboard"));
var _TechDispatcher = _interopRequireDefault(require("../containers/TechDispatcher"));
var _StoreDetails = _interopRequireDefault(require("../containers/StoreDetails"));
var _StoreManagement = _interopRequireDefault(require("../containers/StoreManagement"));
var _helper = require("../common_features/utility/helper");
var _reactRedux = require("react-redux");
var _NotificationPreferences = _interopRequireDefault(require("../containers/NotificationPreferences"));
var _EditProfile = _interopRequireDefault(require("../containers/EditProfile"));
var _ChangeCurrentPassword = _interopRequireDefault(require("../containers/ChangeCurrentPassword"));
var _AddSystem = _interopRequireDefault(require("../containers/AddSystem"));
var _EditWaterDestination = _interopRequireDefault(require("../containers/EditWaterDestination"));
var _SystemDetail = _interopRequireDefault(require("../containers/SystemDetail"));
var _EditSensor = _interopRequireDefault(require("../containers/EditSensor"));
var _EditHub = _interopRequireDefault(require("../containers/EditHub"));
var _EditAccessory = _interopRequireDefault(require("../containers/EditAccessory"));
var _EditFilter = _interopRequireDefault(require("../containers/EditFilter"));
var _StoreAlertsDetails = _interopRequireDefault(require("../containers/StoreAlertsDetails"));
var _StoreAlertList = _interopRequireDefault(require("../containers/StoreAlertList"));
var _EditSensorPlacement = _interopRequireDefault(require("../containers/EditSensorPlacement"));
var _CommonAlertList = _interopRequireDefault(require("../containers/CommonAlertList"));
var _ContactPentair = _interopRequireDefault(require("../containers/ContactPentair"));
var _strings = require("../common_features/utility/strings");
var _AddAccessory = _interopRequireDefault(require("../containers/AddAccessory"));
var _EditSystem = _interopRequireDefault(require("../containers/EditSystem"));
var _AddNotesContainer = _interopRequireDefault(require("../containers/AddNotesContainer"));
var _store = require("../common_features/redux/store");
var _legal = _interopRequireDefault(require("../containers/legal"));
var _SessionTimeout = _interopRequireDefault(require("../components/SessionTimeout"));
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
var _WaterInfo = _interopRequireDefault(require("../containers/WaterInfo"));
var _ServiceLogs = _interopRequireDefault(require("../containers/ServiceLogs/ServiceLogs"));
var _ServiceOperations = _interopRequireDefault(require("../containers/ServiceLogs/ServiceOperations"));
var _ImageUploadContainer = _interopRequireDefault(require("../containers/ImageUploadContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* Import Below Two Lines When hub and Sensor Part will be continued 
    import AddHub from '../containers/AddHub';
    import AddSensor from "../containers/AddSensor"; */

function DispatcherLayout() {
  const [userScreenPrefDispatcher, setUserScreenPrefDispatcher] = (0, _react.useState)(false);
  const [isAuthenticated, setIsAuthenticated] = (0, _react.useState)(false);
  const [userExists, setUserExists] = (0, _react.useState)(true);
  const {
    userInfo,
    currentSideMenuState
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    userScreenPref
  } = (0, _reactRedux.useSelector)(state => state.role);
  const {
    stores
  } = (0, _reactRedux.useSelector)(state => state.stores);
  let {
    gateways
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const {
    data: userDetails
  } = (0, _reactRedux.useSelector)(state => state.userDetails);
  let {
    generalAlerts
  } = (0, _reactRedux.useSelector)(state => state.alert);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [userName, setUserName] = (0, _react.useState)('Guest');
  const val = sessionStorage.getItem("dispReload") ? sessionStorage.getItem("dispReload") : "1";
  const [isClicked, setIsClicked] = (0, _react.useState)(val);
  const [sideMenuState, setSideMenuState] = (0, _react.useState)(false);
  const wssPayload = {
    request: {
      token: ""
    }
  };
  const [wssResponse, setWssResponse] = (0, _react.useState)(null);
  const type = (0, _helper.getPlatformType)();
  let personaDetails = {};
  (0, _helper.getUserTypeForDispatcherLayout)(userInfo, personaDetails);
  (0, _helper.getPersonaName)(userInfo, personaDetails);
  const userTypeType = personaDetails.userTypeType;
  const personaName = personaDetails.personaName;
  const [isAlert, setIsAlert] = (0, _react.useState)(false);
  const dispatch = (0, _reactRedux.useDispatch)();
  const fn = {
    handleEditProfile,
    handleDashBoard,
    handleUserManagment,
    handleStoreManagement,
    contactPentair,
    signOut,
    legal,
    warranty
  };
  const iconList = {
    FaUserCircle: /*#__PURE__*/_react.default.createElement(_fa.FaUserCircle, null),
    FaUserFriends: /*#__PURE__*/_react.default.createElement(_fa.FaUserFriends, null),
    FaStore: /*#__PURE__*/_react.default.createElement(_fa.FaStore, null),
    ArrowRight: _images.ArrowRight.default
  };
  (0, _react.useEffect)(() => {
    const handleBeforeUnload = e => {
      sessionStorage.setItem("dispReload", isClicked);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
  }, [isClicked]);
  const SideMenuButtonItems = (0, _helper.SideMenuButtonItemsWithFn)(userName, type, iconList, fn, personaName, userInfo.userType, isClicked);
  const NavItems = (0, _helper.getNavItems)({
    currentRole: userInfo.userType,
    SideMenuButtonItems
  });
  const toggleMenu = () => {
    (userTypeType || !type || userScreenPrefDispatcher) && setSideMenuState(!sideMenuState);
  };
  const handleHeaderImgClick = () => {
    handleDashBoard();
    if (personaName == "Dispatcher" && type) {
      setIsClicked('1');
    } else {
      setSideMenuState(false);
    }
  };
  (0, _react.useEffect)(() => {
    (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) && setUserName(userInfo.firstName);
  }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName]);
  (0, _react.useEffect)(() => {
    var _window$screen;
    const setOrientationDesign = () => {
      const type = window.screen.orientation.type;
      const angle = window.screen.orientation.angle;
      if (type === "landscape-primary" && angle === 90) {
        dispatch((0, _roleReducer.setUserScreenPref)("Dispatcher_Web_Mobile_View"));
      }
    };
    if (window.screen && ((_window$screen = window.screen) === null || _window$screen === void 0 ? void 0 : _window$screen.orientation) !== null) {
      window.screen.orientation.onchange = setOrientationDesign;
      setOrientationDesign();
    }
  }, []);
  const handleWebMobileToggleMenu = () => {
    setSideMenuState(!sideMenuState);
  };
  (0, _react.useEffect)(() => {
    return () => {};
  }, [isClicked]);
  (0, _react.useEffect)(() => {
    if (userScreenPref === "Dispatcher_Web_Mobile_View" && sessionStorage.getItem("Dispatcher_Web_Mobile_View")) {
      setIsClicked("2");
      handleWebMobileToggleMenu();
      setUserScreenPrefDispatcher(true);
    } else {
      setUserScreenPrefDispatcher(false);
      setSideMenuState(true);
    }
    return () => {};
  }, [userScreenPref]);
  (0, _react.useEffect)(() => {
    (userDetails === null || userDetails === void 0 ? void 0 : userDetails.firstName) && setUserName(userDetails === null || userDetails === void 0 ? void 0 : userDetails.firstName);
  }, [userDetails === null || userDetails === void 0 ? void 0 : userDetails.firstName]);
  (0, _react.useEffect)(() => {
    (0, _helper.getStoreListItems)(dispatch, _storesReducer.storesInfo);
  }, []);
  (0, _react.useEffect)(() => {
    if (currentSideMenuState) {
      setIsClicked(currentSideMenuState);
    }
  }, [currentSideMenuState]);
  (0, _react.useEffect)(() => {
    const customCall = async () => {
      var _userDetails$UserNoti;
      setIsAlert(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$UserNoti = userDetails.UserNotifyPref) === null || _userDetails$UserNoti === void 0 ? void 0 : _userDetails$UserNoti.isNotifyIconClicked);
      await (0, _helper.getStoresInfo)(wssPayload, setWssResponse, setIsAlert, dispatch, stores, generalAlerts, navigate, userInfo.userType);
      setSideMenuState(getViewType() && (!userScreenPref || !sessionStorage.getItem("Dispatcher_Web_Mobile_View")) ? true : false);
      _awsAmplify.Auth.currentUserInfo().then(() => {}).catch(() => {
        setUserExists(false);
      });
    };
    customCall();
  }, []);
  (0, _react.useEffect)(() => {
    (0, _helper.setStoreAndGateway)(wssResponse, gateways, dispatch);
  }, [wssResponse]);
  (0, _react.useEffect)(() => {
    (0, _helper.setNotifyPref)(userDetails, setIsAlert);
  }, [userDetails === null || userDetails === void 0 ? void 0 : userDetails.UserNotifyPref]);
  function handleStoreManagement() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    setIsClicked('2');
    // navigate('/App/UserManage')
    navigate(_RoutePath.default.manageStore.useLink);
    toggleMenu();
  }
  function signOut() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.removeItem("dispReload");
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    _awsAmplify.Auth.signOut().then(data => {
      setUserName('Guest');
      _store.store.dispatch({
        type: 'RESET'
      });
      navigate(_RoutePath.default.login.useLink);
    }).catch(error => {});
  }
  function handleUserManagment() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    // navigate('/App/UserManage')
    setIsClicked('1');
    navigate(_RoutePath.default.userManage.useLink);
    toggleMenu();
  }
  function legal() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    setIsClicked('3');
    navigate(_RoutePath.default.legal.useLink);
    toggleMenu();
  }
  function contactPentair() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    setIsClicked('5');
    navigate(_RoutePath.default.contactPentair.useLink);
    toggleMenu();
  }
  function handleEditProfile() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    // navigate('/App/UserManage')
    navigate(_RoutePath.default.editProfile.useLink);
    toggleMenu();
  }
  function warranty() {
    dispatch((0, _roleReducer.setUserScreenPref)(""));
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 0);
    setSideMenuState(true);
    setIsClicked('4');
    window.open('https://www.pentair.com/assets/foodservice-warranty', '_blank', "noopener");
  }
  function handleDashBoard() {
    if (userScreenPref !== "" && sessionStorage.getItem("Dispatcher_Web_Mobile_View")) {
      dispatch((0, _roleReducer.setUserScreenPref)(""));
      navigate(_RoutePath.default.userManage.useLink);
    } else {
      navigate(_RoutePath.default.dispatcherStoreDashboard.useLink);
    }
    toggleMenu();
  }
  function handleNotificationIconClick() {
    navigate(_RoutePath.default.NotificationsList.useLink);
    setIsAlert(false);
  }
  const getViewType = () => {
    return type && !userTypeType && !userScreenPrefDispatcher || false;
  };
  const sessionCheck = async () => {
    const currentSession = await _awsAmplify.Auth.currentSession();
    if (!(0, _helper.isSessionTimeout)() && currentSession) {
      setIsAuthenticated(true);
    } else {
      handleLogout();
    }
  };
  (0, _react.useEffect)(() => {
    sessionCheck();
  }, []);
  const handleLogout = () => {
    _helper.logoutChannel.postMessage('logout');
    _awsAmplify.Auth.signOut().then(() => {
      setIsAuthenticated(false);
      dispatch({
        type: 'RESET'
      });
      window.clearInterval(window.sessionInterval);
      localStorage.clear();
      sessionStorage.clear();
      navigate('/Login');
      dispatch((0, _loginReducer.clearLogin)());
    }).catch(e => console.log('Error Auth sign out=>', e));
  };
  const logoutAllTabs = () => {
    _helper.logoutChannel.onmessage = () => {
      handleLogout();
      _helper.logoutChannel.close();
    };
  };
  const loginAllTabs = () => {
    _helper.loginChannel.onmessage = () => {
      _helper.loginChannel.close();
      window.location.reload();
    };
  };
  (0, _react.useEffect)(() => {
    loginAllTabs();
    logoutAllTabs();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true,
    className: "dispatcherLayout"
  }, userExists ? null : navigate(_RoutePath.default.login.useLink) && localStorage.clear(), isAuthenticated && /*#__PURE__*/_react.default.createElement(_SessionTimeout.default, {
    handleLogout: handleLogout
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "dispatcherFirstRow"
  }, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    leftImage: _images.hem_burger_icon.default,
    style: {
      position: 'fixed',
      zIndex: "99",
      height: _helper.headerHeight
    },
    type: getViewType() ? "Desktop" : "",
    onLeftClick: toggleMenu,
    onHeaderImgClick: handleHeaderImgClick,
    onRightClick: handleNotificationIconClick,
    imageUrl: getViewType() ? _images.Pentair_Logo_white.default : _images.Pentair_Logo.default,
    imageStyle: {
      cursor: 'pointer'
    },
    rightImage: isAlert ? _images.Alert_Icon_Red.default : _images.Alert_Icon.default,
    rightText: getViewType() ? 'Provide your business with clean, clear, expertly managed water' : '',
    rightImageStyle: {
      cursor: "pointer"
    },
    rightTextStyle: {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '28px',
      color: '#ffffff',
      cursor: "pointer"
    },
    leftImageStyle: {
      cursor: "pointer"
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "dispatcherSecondRow"
  }, /*#__PURE__*/_react.default.createElement(_SideMenu.SideMenu, {
    style: {
      marginTop: getViewType() ? _helper.headerHeight : "0",
      width: "252px",
      zIndex: 99,
      height: getViewType() ? "" : "100%"
    },
    NavItems: NavItems,
    menuState: sideMenuState,
    sideBarOneStyle: {
      width: '100%',
      marginTop: "20px"
    },
    onClick: toggleMenu,
    closeButtonIcon: _images.CloseIcon.default,
    isDesktop: getViewType() ? true : false,
    userScreenPrefDispatcher: userScreenPrefDispatcher,
    isPortrait: userTypeType && !type || userScreenPrefDispatcher ? true : false,
    version: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: "rgba(88, 89, 91, 0.501274)",
        width: "100%",
        position: 'relative',
        padding: "1.6em",
        fontSize: 13,
        fontFamily: "Poppins",
        lineHeight: "20px",
        fontWeight: 400,
        marginTop: "auto"
      }
    }, "Version ".concat(_strings.versionControl.version, "(").concat(_strings.versionControl.buildNumber, ")"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dispatcherRoutes",
    style: {
      paddingTop: _helper.headerHeight,
      overflow: 'overlay',
      paddingLeft: getViewType() ? "252px" : "0px",
      paddingRight: "0px",
      height: "100vh"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, type ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.manageStore.path,
    element: /*#__PURE__*/_react.default.createElement(_StoreManagement.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.storeDetails.path,
    element: /*#__PURE__*/_react.default.createElement(_StoreDetails.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.userManage.path,
    element: /*#__PURE__*/_react.default.createElement(_index.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.addUserInvite.path,
    element: /*#__PURE__*/_react.default.createElement(_AddEmployee.default, null)
  })) : null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.basePath.path,
    element: getViewType() ? /*#__PURE__*/_react.default.createElement(_index.default, null) : /*#__PURE__*/_react.default.createElement(_DispatcherStoreDashboard.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.dispatcherStoreDashboard.path,
    element: getViewType() ? /*#__PURE__*/_react.default.createElement(_index.default, null) : /*#__PURE__*/_react.default.createElement(_DispatcherStoreDashboard.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.techDispatcher.path,
    element: /*#__PURE__*/_react.default.createElement(_TechDispatcher.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.NotificationPreferences.path,
    element: /*#__PURE__*/_react.default.createElement(_NotificationPreferences.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editProfile.path,
    element: /*#__PURE__*/_react.default.createElement(_EditProfile.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.addSystem.path,
    element: /*#__PURE__*/_react.default.createElement(_AddSystem.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.serviceLogs.path,
    element: /*#__PURE__*/_react.default.createElement(_ServiceLogs.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.imageUpload.path,
    element: /*#__PURE__*/_react.default.createElement(_ImageUploadContainer.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.serviceLogOperations.path,
    element: /*#__PURE__*/_react.default.createElement(_ServiceOperations.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editWaterDestination.path,
    element: /*#__PURE__*/_react.default.createElement(_EditWaterDestination.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.ChangeCurrentPassword.path,
    element: /*#__PURE__*/_react.default.createElement(_ChangeCurrentPassword.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.systemDetail.path,
    element: /*#__PURE__*/_react.default.createElement(_SystemDetail.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.StoreAlertsDetails.path,
    element: /*#__PURE__*/_react.default.createElement(_StoreAlertsDetails.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.StoreAlertList.path,
    element: /*#__PURE__*/_react.default.createElement(_StoreAlertList.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.NotificationsList.path,
    element: /*#__PURE__*/_react.default.createElement(_CommonAlertList.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.EditSensor.path,
    element: /*#__PURE__*/_react.default.createElement(_EditSensor.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editAccessory.path,
    element: /*#__PURE__*/_react.default.createElement(_EditAccessory.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editFilter.path,
    element: /*#__PURE__*/_react.default.createElement(_EditFilter.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.gatewayDetail.path,
    element: /*#__PURE__*/_react.default.createElement(_EditHub.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editSensorPlacement.path,
    element: /*#__PURE__*/_react.default.createElement(_EditSensorPlacement.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.contactPentair.path,
    element: /*#__PURE__*/_react.default.createElement(_ContactPentair.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.addAccessory.path,
    element: /*#__PURE__*/_react.default.createElement(_AddAccessory.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.editSystem.path,
    element: /*#__PURE__*/_react.default.createElement(_EditSystem.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.addNotes.path,
    element: /*#__PURE__*/_react.default.createElement(_AddNotesContainer.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.legal.path,
    element: /*#__PURE__*/_react.default.createElement(_legal.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.WaterInfo.path,
    element: /*#__PURE__*/_react.default.createElement(_WaterInfo.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "*",
    element: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
      to: "/"
    })
  })))));
}